export default "__VITE_ASSET__oO6DkXkT__"